import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { formatDateYYYY_MM_DD } from "../../functions/common-functions";

const ReviseDueDateModal = ({ 
  show, 
  onHide, 
  revisedDueDate, 
  setRevisedDueDate, 
  onSave, 
  loading 
}) => {
  return (
    <Modal show={show} onHide={onHide} size="sm" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Revise Due Date</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="g-input">
          <Form.Control
            id="RevisedDueDate"
            type="date"
            name="RevisedDueDate"
            placeholder=" "
            value={revisedDueDate}
            onChange={(e) => setRevisedDueDate(e.target.value)}
            min={formatDateYYYY_MM_DD(new Date())}
          />
          <Form.Label htmlFor="RevisedDueDate">Revised Due Date</Form.Label>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="swal2-styled swal2-deny"
          variant="secondary"
          onClick={onHide}
        >
          Cancel
        </Button>
        <Button
          variant="success"
          className="btn-add-color semiBoldToggleButton rightAlignedButton"
          onClick={onSave}
          disabled={loading}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReviseDueDateModal;